/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface LoginResultDTO {
  emailAddress: string;
  hasError: boolean;
  roleId: number;
  message: string;
  /** Indicates that a user has or has not been reviewed by an admin */
  isReviewed: boolean;
  isEmailConfirmed: boolean;
  /** Indicates if an account has been activated, IE after it has been created */
  isActivated: boolean;
  /** Indicates that two factor is enabled */
  isTFAEnabled: boolean;
  /** Indicates if user has successfully passed tfa or not */
  isTFAVerified: boolean;
  /** Text, email or app potentially */
  tfaType: string;
  /** Final step, full authentication */
  isAuthenticated: boolean;
}
const LoginResultDTO = {
  create: (initValues?: Partial<LoginResultDTO> | null): LoginResultDTO => {
    const defaults: LoginResultDTO = {
      emailAddress: "",
      hasError: false,
      roleId: 0,
      message: "",
      isReviewed: false,
      isEmailConfirmed: false,
      isActivated: false,
      isTFAEnabled: false,
      isTFAVerified: false,
      tfaType: "",
      isAuthenticated: false,
    };
    const fixedValues: Partial<LoginResultDTO> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default LoginResultDTO;
